export const removeEmptyKeys = (obj: any) => {
  Object.entries(obj).forEach(([key, value]) => {
    if (value === null || value === undefined || value === '') {
      delete obj[key];
    }
  });
  return obj;
};
